import { styled } from 'linaria/react';

export const PriceCalculateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: var(--space-300);
  margin-top: var(--space-250);
  margin-bottom: var(--space-250);
  background: var(--service-light);
  border-radius: var(--space-100);

  @media (--to-tablet) {
    margin-bottom: 0px;
  }

  @media (max-width: 500px) {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-200);

    & > button {
      width: 100%;
    }
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-100);
`;
